[
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124001.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124001",
		"analysisNo": "124001",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.02,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "gleitgeschliffen und gewaschen 23.06.2017",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.04743,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 178.0,
		"woF_15_25": 138.0,
		"woF_25_50": 226.0,
		"woF_50_100": 124.0,
		"woF_100_150": 19.0,
		"woF_150_200": 3.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 178.0,
		"All_15_25": 138.0,
		"All_25_50": 226.0,
		"All_50_100": 124.0,
		"All_100_150": 21.0,
		"All_150_200": 5.0,
		"All_200_400": 4.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 4.0,
		"All_300_400": 3.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 3.0,
		"Met_15_25": 2.0,
		"Met_25_50": 1.0,
		"Met_50_100": 6.0,
		"Met_100_150": 7.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 154.0,
		"woFNM_1W": 43.0,
		"woFNM_2L": 154.0,
		"woFNM_2W": 61.0,
		"woFNM_3L": 138.0,
		"woFNM_3W": 75.0,
		"woFNM_4L": 133.0,
		"woFNM_4W": 84.0,
		"woFNM_5L": 128.0,
		"woFNM_5W": 27.0,
		"Met_1L": 169.0,
		"Met_1W": 78.0,
		"Met_2L": 144.0,
		"Met_2W": 97.0,
		"Met_3L": 136.0,
		"Met_3W": 81.0,
		"Met_4L": 135.0,
		"Met_4W": 68.0,
		"Met_5L": 120.0,
		"Met_5W": 43.0,
		"Fib_Fmax1_Fmax": 5134.0,
		"Fib_Fmax1_Lstr": 6028.0,
		"Fib_Fmax2_Fmax": 932.0,
		"Fib_Fmax2_Lstr": 959.0,
		"Fib_Lstr1_Fmax": 5134.0,
		"Fib_Lstr1_Lstr": 6028.0,
		"Fib_Fmax_Sum_um": 9004.0,
		"Fib_Stretched_Sum_um": 10533.0,
		"woF_weighted_sum": 227.0,
		"All_weighted_sum": 1069.0,
		"Met_weighted_sum": 43.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124001,
		"Passed": "1",
		"met_sum": 14.0,
		"nm_sum": 132.0,
		"sum_fibers": 12.0,
		"fibers_sum": 12.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124002.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124002",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.059829,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 307.0,
		"woF_15_25": 113.0,
		"woF_25_50": 159.0,
		"woF_50_100": 102.0,
		"woF_100_150": 12.0,
		"woF_150_200": 7.0,
		"woF_200_400": 1.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 307.0,
		"All_15_25": 113.0,
		"All_25_50": 159.0,
		"All_50_100": 102.0,
		"All_100_150": 12.0,
		"All_150_200": 8.0,
		"All_200_400": 6.0,
		"All_400_600": 5.0,
		"All_600_1000": 9.0,
		"All_gt_1000": 6.0,
		"All_200_300": 20.0,
		"All_300_400": 15.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 4.0,
		"All_800_900": 2.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3.0,
		"Met_15_25": 3.0,
		"Met_25_50": 6.0,
		"Met_50_100": 15.0,
		"Met_100_150": 1.0,
		"Met_150_200": 3.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 417.0,
		"woFNM_1W": 297.0,
		"woFNM_2L": 229.0,
		"woFNM_2W": 109.0,
		"woFNM_3L": 192.0,
		"woFNM_3W": 57.0,
		"woFNM_4L": 184.0,
		"woFNM_4W": 86.0,
		"woFNM_5L": 160.0,
		"woFNM_5W": 24.0,
		"Met_1L": 159.0,
		"Met_1W": 27.0,
		"Met_2L": 154.0,
		"Met_2W": 38.0,
		"Met_3L": 152.0,
		"Met_3W": 49.0,
		"Met_4L": 127.0,
		"Met_4W": 38.0,
		"Met_5L": 99.0,
		"Met_5W": 49.0,
		"Fib_Fmax1_Fmax": 1820.0,
		"Fib_Fmax1_Lstr": 2660.0,
		"Fib_Fmax2_Fmax": 1768.0,
		"Fib_Fmax2_Lstr": 3344.0,
		"Fib_Lstr1_Fmax": 1768.0,
		"Fib_Lstr1_Lstr": 3344.0,
		"Fib_Fmax_Sum_um": 19217.0,
		"Fib_Stretched_Sum_um": 26044.0,
		"woF_weighted_sum": 293.0,
		"All_weighted_sum": 4334.0,
		"Met_weighted_sum": 46.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124002,
		"Passed": null,
		"met_sum": 19.0,
		"nm_sum": 104.0,
		"fibers_sum": 25.0,
		"sum_fibers": 25.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124003.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124003",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.07,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nach Waschen",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.021012,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 174.0,
		"woF_15_25": 76.0,
		"woF_25_50": 96.0,
		"woF_50_100": 49.0,
		"woF_100_150": 4.0,
		"woF_150_200": 2.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 174.0,
		"All_15_25": 76.0,
		"All_25_50": 96.0,
		"All_50_100": 49.0,
		"All_100_150": 4.0,
		"All_150_200": 3.0,
		"All_200_400": 4.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 3.0,
		"All_200_300": 3.0,
		"All_300_400": 3.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 5.0,
		"Met_25_50": 7.0,
		"Met_50_100": 8.0,
		"Met_100_150": 4.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 290.0,
		"woFNM_1W": 48.0,
		"woFNM_2L": 191.0,
		"woFNM_2W": 27.0,
		"woFNM_3L": 93.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 88.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 81.0,
		"woFNM_5W": 65.0,
		"Met_1L": 187.0,
		"Met_1W": 70.0,
		"Met_2L": 149.0,
		"Met_2W": 59.0,
		"Met_3L": 136.0,
		"Met_3W": 34.0,
		"Met_4L": 108.0,
		"Met_4W": 72.0,
		"Met_5L": 104.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 1538.0,
		"Fib_Fmax1_Lstr": 2312.0,
		"Fib_Fmax2_Fmax": 1359.0,
		"Fib_Fmax2_Lstr": 1383.0,
		"Fib_Lstr1_Fmax": 1301.0,
		"Fib_Lstr1_Lstr": 2514.0,
		"Fib_Fmax_Sum_um": 5262.0,
		"Fib_Stretched_Sum_um": 7408.0,
		"woF_weighted_sum": 99.0,
		"All_weighted_sum": 1356.0,
		"Met_weighted_sum": 33.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124003,
		"Passed": null,
		"met_sum": 13.0,
		"nm_sum": 43.0,
		"fibers_sum": 7.0,
		"sum_fibers": 7.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124004.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124004",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.0,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nach Waschen",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.016238,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 167.0,
		"woF_15_25": 53.0,
		"woF_25_50": 108.0,
		"woF_50_100": 35.0,
		"woF_100_150": 6.0,
		"woF_150_200": 2.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 167.0,
		"All_15_25": 53.0,
		"All_25_50": 108.0,
		"All_50_100": 35.0,
		"All_100_150": 6.0,
		"All_150_200": 2.0,
		"All_200_400": 1.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 1.0,
		"All_200_300": 2.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 0.0,
		"Met_25_50": 13.0,
		"Met_50_100": 26.0,
		"Met_100_150": 4.0,
		"Met_150_200": 2.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 149.0,
		"woFNM_1W": 15.0,
		"woFNM_2L": 136.0,
		"woFNM_2W": 48.0,
		"woFNM_3L": 84.0,
		"woFNM_3W": 53.0,
		"woFNM_4L": 65.0,
		"woFNM_4W": 21.0,
		"woFNM_5L": 55.0,
		"woFNM_5W": 27.0,
		"Met_1L": 179.0,
		"Met_1W": 111.0,
		"Met_2L": 152.0,
		"Met_2W": 75.0,
		"Met_3L": 125.0,
		"Met_3W": 27.0,
		"Met_4L": 124.0,
		"Met_4W": 46.0,
		"Met_5L": 107.0,
		"Met_5W": 32.0,
		"Fib_Fmax1_Fmax": 1475.0,
		"Fib_Fmax1_Lstr": 1741.0,
		"Fib_Fmax2_Fmax": 448.0,
		"Fib_Fmax2_Lstr": 685.0,
		"Fib_Lstr1_Fmax": 1475.0,
		"Fib_Lstr1_Lstr": 1741.0,
		"Fib_Fmax_Sum_um": 2219.0,
		"Fib_Stretched_Sum_um": 2728.0,
		"woF_weighted_sum": 77.0,
		"All_weighted_sum": 557.0,
		"Met_weighted_sum": 60.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124004,
		"Passed": null,
		"met_sum": 32.0,
		"nm_sum": 11.0,
		"fibers_sum": 3.0,
		"sum_fibers": 3.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124005.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124005",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nach Waschen / 14.05.2018",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,3 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.006516,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 75.0,
		"woF_15_25": 55.0,
		"woF_25_50": 69.0,
		"woF_50_100": 17.0,
		"woF_100_150": 2.0,
		"woF_150_200": 0.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 75.0,
		"All_15_25": 55.0,
		"All_25_50": 69.0,
		"All_50_100": 17.0,
		"All_100_150": 2.0,
		"All_150_200": 0.0,
		"All_200_400": 0.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 0.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 0.0,
		"Met_15_25": 1.0,
		"Met_25_50": 10.0,
		"Met_50_100": 10.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 95.0,
		"woFNM_1W": 38.0,
		"woFNM_2L": 72.0,
		"woFNM_2W": 21.0,
		"woFNM_3L": 71.0,
		"woFNM_3W": 37.0,
		"woFNM_4L": 58.0,
		"woFNM_4W": 21.0,
		"woFNM_5L": 54.0,
		"woFNM_5W": 21.0,
		"Met_1L": 136.0,
		"Met_1W": 53.0,
		"Met_2L": 106.0,
		"Met_2W": 21.0,
		"Met_3L": 77.0,
		"Met_3W": 19.0,
		"Met_4L": 70.0,
		"Met_4W": 37.0,
		"Met_5L": 65.0,
		"Met_5W": 8.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 25.0,
		"All_weighted_sum": 25.0,
		"Met_weighted_sum": 18.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124005,
		"Passed": null,
		"met_sum": 12.0,
		"nm_sum": 7.0,
		"fibers_sum": 0.0,
		"sum_fibers": 0.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124006.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124006",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.05,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.067943,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 462.0,
		"woF_15_25": 375.0,
		"woF_25_50": 491.0,
		"woF_50_100": 174.0,
		"woF_100_150": 23.0,
		"woF_150_200": 5.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 462.0,
		"All_15_25": 375.0,
		"All_25_50": 491.0,
		"All_50_100": 174.0,
		"All_100_150": 23.0,
		"All_150_200": 5.0,
		"All_200_400": 1.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 0.0,
		"Met_25_50": 3.0,
		"Met_50_100": 11.0,
		"Met_100_150": 12.0,
		"Met_150_200": 3.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 155.0,
		"woFNM_1W": 107.0,
		"woFNM_2L": 152.0,
		"woFNM_2W": 81.0,
		"woFNM_3L": 128.0,
		"woFNM_3W": 51.0,
		"woFNM_4L": 116.0,
		"woFNM_4W": 75.0,
		"woFNM_5L": 113.0,
		"woFNM_5W": 70.0,
		"Met_1L": 200.0,
		"Met_1W": 59.0,
		"Met_2L": 172.0,
		"Met_2W": 102.0,
		"Met_3L": 164.0,
		"Met_3W": 54.0,
		"Met_4L": 154.0,
		"Met_4W": 59.0,
		"Met_5L": 137.0,
		"Met_5W": 91.0,
		"Fib_Fmax1_Fmax": 527.0,
		"Fib_Fmax1_Lstr": 866.0,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": 527.0,
		"Fib_Lstr1_Lstr": 866.0,
		"Fib_Fmax_Sum_um": 527.0,
		"Fib_Stretched_Sum_um": 866.0,
		"woF_weighted_sum": 327.0,
		"All_weighted_sum": 391.0,
		"Met_weighted_sum": 102.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124006,
		"Passed": null,
		"met_sum": 27.0,
		"nm_sum": 176.0,
		"fibers_sum": 1.0,
		"sum_fibers": 1.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124007.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124007",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.03,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Blech",
		"Component_No": null,
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.010999,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 199.0,
		"woF_15_25": 63.0,
		"woF_25_50": 55.0,
		"woF_50_100": 28.0,
		"woF_100_150": 4.0,
		"woF_150_200": 2.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 199.0,
		"All_15_25": 63.0,
		"All_25_50": 55.0,
		"All_50_100": 28.0,
		"All_100_150": 4.0,
		"All_150_200": 2.0,
		"All_200_400": 2.0,
		"All_400_600": 1.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 0.0,
		"All_200_300": 2.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 2.0,
		"Met_25_50": 4.0,
		"Met_50_100": 11.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 182.0,
		"woFNM_1W": 22.0,
		"woFNM_2L": 156.0,
		"woFNM_2W": 31.0,
		"woFNM_3L": 131.0,
		"woFNM_3W": 27.0,
		"woFNM_4L": 130.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 121.0,
		"woFNM_5W": 46.0,
		"Met_1L": 200.0,
		"Met_1W": 22.0,
		"Met_2L": 84.0,
		"Met_2W": 27.0,
		"Met_3L": 83.0,
		"Met_3W": 27.0,
		"Met_4L": 82.0,
		"Met_4W": 43.0,
		"Met_5L": 79.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 635.0,
		"Fib_Fmax1_Lstr": 654.0,
		"Fib_Fmax2_Fmax": 522.0,
		"Fib_Fmax2_Lstr": 809.0,
		"Fib_Lstr1_Fmax": 522.0,
		"Fib_Lstr1_Lstr": 809.0,
		"Fib_Fmax_Sum_um": 1506.0,
		"Fib_Stretched_Sum_um": 1840.0,
		"woF_weighted_sum": 78.0,
		"All_weighted_sum": 302.0,
		"Met_weighted_sum": 27.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124007,
		"Passed": null,
		"met_sum": 12.0,
		"nm_sum": 23.0,
		"fibers_sum": 3.0,
		"sum_fibers": 3.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124008.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124008",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.18,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.035207,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 262.0,
		"woF_15_25": 179.0,
		"woF_25_50": 245.0,
		"woF_50_100": 106.0,
		"woF_100_150": 6.0,
		"woF_150_200": 1.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 262.0,
		"All_15_25": 179.0,
		"All_25_50": 245.0,
		"All_50_100": 106.0,
		"All_100_150": 6.0,
		"All_150_200": 1.0,
		"All_200_400": 1.0,
		"All_400_600": 0.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 0.0,
		"All_200_300": 3.0,
		"All_300_400": 3.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 1.0,
		"Met_25_50": 4.0,
		"Met_50_100": 31.0,
		"Met_100_150": 3.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 188.0,
		"woFNM_1W": 134.0,
		"woFNM_2L": 118.0,
		"woFNM_2W": 34.0,
		"woFNM_3L": 109.0,
		"woFNM_3W": 64.0,
		"woFNM_4L": 104.0,
		"woFNM_4W": 43.0,
		"woFNM_5L": 98.0,
		"woFNM_5W": 27.0,
		"Met_1L": 145.0,
		"Met_1W": 86.0,
		"Met_2L": 113.0,
		"Met_2W": 37.0,
		"Met_3L": 106.0,
		"Met_3W": 24.0,
		"Met_4L": 100.0,
		"Met_4W": 37.0,
		"Met_5L": 98.0,
		"Met_5W": 70.0,
		"Fib_Fmax1_Fmax": 842.0,
		"Fib_Fmax1_Lstr": 1398.0,
		"Fib_Fmax2_Fmax": 677.0,
		"Fib_Fmax2_Lstr": 694.0,
		"Fib_Lstr1_Fmax": 842.0,
		"Fib_Lstr1_Lstr": 1398.0,
		"Fib_Fmax_Sum_um": 2378.0,
		"Fib_Stretched_Sum_um": 2966.0,
		"woF_weighted_sum": 139.0,
		"All_weighted_sum": 587.0,
		"Met_weighted_sum": 43.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124008,
		"Passed": null,
		"met_sum": 34.0,
		"nm_sum": 79.0,
		"fibers_sum": 4.0,
		"sum_fibers": 4.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124009.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "125009",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.06,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "Blech 2927 Sta-FKS-Wasch-Verp. 10 Stk 1.3.19",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.032126,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 3301.0,
		"woF_15_25": 432.0,
		"woF_25_50": 108.0,
		"woF_50_100": 23.0,
		"woF_100_150": 3.0,
		"woF_150_200": 1.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 3301.0,
		"All_15_25": 432.0,
		"All_25_50": 108.0,
		"All_50_100": 23.0,
		"All_100_150": 3.0,
		"All_150_200": 1.0,
		"All_200_400": 0.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 106.0,
		"Met_15_25": 45.0,
		"Met_25_50": 7.0,
		"Met_50_100": 0.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 158.0,
		"woFNM_1W": 38.0,
		"woFNM_2L": 121.0,
		"woFNM_2W": 92.0,
		"woFNM_3L": 120.0,
		"woFNM_3W": 43.0,
		"woFNM_4L": 110.0,
		"woFNM_4W": 22.0,
		"woFNM_5L": 81.0,
		"woFNM_5W": 27.0,
		"Met_1L": 48.0,
		"Met_1W": 29.0,
		"Met_2L": 41.0,
		"Met_2W": 22.0,
		"Met_3L": 34.0,
		"Met_3W": 16.0,
		"Met_4L": 32.0,
		"Met_4W": 22.0,
		"Met_5L": 28.0,
		"Met_5W": 15.0,
		"Fib_Fmax1_Fmax": 482.0,
		"Fib_Fmax1_Lstr": 691.0,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": 482.0,
		"Fib_Lstr1_Lstr": 691.0,
		"Fib_Fmax_Sum_um": 482.0,
		"Fib_Stretched_Sum_um": 691.0,
		"woF_weighted_sum": 44.0,
		"All_weighted_sum": 108.0,
		"Met_weighted_sum": 0.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124009,
		"Passed": null,
		"met_sum": 0.0,
		"nm_sum": 27.0,
		"fibers_sum": 1.0,
		"sum_fibers": 1.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Blech",
		"zeichnr": "Blech",
		"betaufnr": 124010.0,
		"kdnr": 12345.0,
		"artnr": "5123433",
		"Analysis_No": "124010",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": 6.27,
		"Weight_mg": 0.02,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Blech",
		"Component_No": "-",
		"Testing_Specification": "5123433",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.037619,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 171.0,
		"woF_15_25": 104.0,
		"woF_25_50": 154.0,
		"woF_50_100": 101.0,
		"woF_100_150": 16.0,
		"woF_150_200": 3.0,
		"woF_200_400": 3.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 171.0,
		"All_15_25": 104.0,
		"All_25_50": 154.0,
		"All_50_100": 101.0,
		"All_100_150": 16.0,
		"All_150_200": 3.0,
		"All_200_400": 7.0,
		"All_400_600": 0.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 2.0,
		"All_200_300": 3.0,
		"All_300_400": 3.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 0.0,
		"Met_15_25": 2.0,
		"Met_25_50": 5.0,
		"Met_50_100": 16.0,
		"Met_100_150": 5.0,
		"Met_150_200": 2.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 363.0,
		"woFNM_1W": 231.0,
		"woFNM_2L": 255.0,
		"woFNM_2W": 145.0,
		"woFNM_3L": 231.0,
		"woFNM_3W": 118.0,
		"woFNM_4L": 177.0,
		"woFNM_4W": 75.0,
		"woFNM_5L": 141.0,
		"woFNM_5W": 68.0,
		"Met_1L": 154.0,
		"Met_1W": 68.0,
		"Met_2L": 150.0,
		"Met_2W": 48.0,
		"Met_3L": 132.0,
		"Met_3W": 70.0,
		"Met_4L": 124.0,
		"Met_4W": 70.0,
		"Met_5L": 114.0,
		"Met_5W": 48.0,
		"Fib_Fmax1_Fmax": 2063.0,
		"Fib_Fmax1_Lstr": 2888.0,
		"Fib_Fmax2_Fmax": 1036.0,
		"Fib_Fmax2_Lstr": 1105.0,
		"Fib_Lstr1_Fmax": 2063.0,
		"Fib_Lstr1_Lstr": 2888.0,
		"Fib_Fmax_Sum_um": 4926.0,
		"Fib_Stretched_Sum_um": 6037.0,
		"woF_weighted_sum": 240.0,
		"All_weighted_sum": 1248.0,
		"Met_weighted_sum": 54.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 124010,
		"Passed": null,
		"met_sum": 23.0,
		"nm_sum": 100.0,
		"fibers_sum": 6.0,
		"sum_fibers": 6.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	}
]
